import { StateCreator } from "zustand";
import { MiscStore } from "./misc.slice";
import { NavStore } from "./navigation.slice";
import { UserStore } from "./user.slice";

type ColumnVisibilityStoreState = {
  // Persistence key (`${userId}:${tableId}`) -> ids of HIDDEN columns.
  // Storing hidden (not visible) ids keeps newly shipped columns visible
  // for users with saved settings.
  hiddenColumnsByTable: Record<string, string[]>;
};

type ColumnVisibilityStoreActions = {
  toggleHiddenColumn: (key: string, columnId: string) => void;
  resetHiddenColumns: (key: string) => void;
};

export type ColumnVisibilityStore = ColumnVisibilityStoreState &
  ColumnVisibilityStoreActions;

export const defaultColumnVisibilityState: ColumnVisibilityStoreState = {
  hiddenColumnsByTable: {},
};

export const createColumnVisibilitySlice: StateCreator<
  ColumnVisibilityStore & UserStore & MiscStore & NavStore,
  [["zustand/devtools", never], ["zustand/immer", never]],
  [["zustand/persist", ColumnVisibilityStore]],
  ColumnVisibilityStore
> = (set) => ({
  ...defaultColumnVisibilityState,
  toggleHiddenColumn: (key: string, columnId: string) =>
    set((state: ColumnVisibilityStore) => {
      const hidden = state.hiddenColumnsByTable[key] ?? [];
      state.hiddenColumnsByTable[key] = hidden.includes(columnId)
        ? hidden.filter((id) => id !== columnId)
        : [...hidden, columnId];
    }),
  resetHiddenColumns: (key: string) =>
    set((state: ColumnVisibilityStore) => {
      delete state.hiddenColumnsByTable[key];
    }),
});
